const en = {
  firstSentence:
    '“This project is my knowledge contribution to society. Here I spend most of my spare time with zero commercial interest since 2019. ',
  highlightedSentence: 'Everything here will always be free.',
  secondSentence: 'Learn. Grow. Share”',
};

export default en;
